import React from 'react'
import { Link } from 'react-router-dom'
// CSS
import '../assets/css/footer.css'
// Images
import Branding from '../logo.png'

export default function Footer() {
  return (
    <footer>
      <div className='container'>
        <div className='footer_sections'>
          <div className='card about'>
            <div className='title select_n'>About Us</div>
            <div className='content'>
              <div className='branding select_n'><img src={Branding} /></div>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis nec vestibulum magna, et dapibus lacus. Duis nec vestibulum magna, et dapibus lacus. <Link to='' className='select_n'>Read More</Link></p>
            </div>
          </div>

          <div className='card contact'>
            <div className='title select_n'>Contact Info</div>
            <div className='content'>
              <div className='contact_info'>
                <div className='contact_title'>Address:</div>
                <span>123 Street Name, City, England</span>
              </div>
              <div className='contact_info'>
                <div className='contact_title'>Phone:</div>
                <span>(123) 456-7890</span>
              </div>
              <div className='contact_info'>
                <div className='contact_title'>Email:</div>
                <span>mail@example.com</span>
              </div>
              <div className='contact_info'>
                <div className='contact_title'>Working Days/Hours:</div>
                <span>Mon - Sun / 9:00 AM - 8:00 PM</span>
              </div>
            </div>
          </div>

          <div className='card customer_service'>
            <div className='title select_n'>Customer Service</div>

            <div className='content select_n'>
              <Link to='/my-account'>My Account</Link>
              <Link to='/wishlist'>Wishlist</Link>
              <Link to='/order-tracking'>Order Tracking</Link>
              <Link to='/my-account/orders'>Orders History</Link>
              <Link to='/help'>Help & FAQs</Link>
              <Link to='/about'>About Us</Link>
              <Link to='/contact'>Contact Us</Link>
              <Link to='/privacy'>Privacy</Link>
            </div>
          </div>

          <div className='card tags select_n'>
            <div className='title'>Popular Tags</div>
            <div className='content'>
              <Link className='tag' to=''>Bag</Link>
              <Link className='tag' to=''>Black</Link>
              <Link className='tag' to=''>Mens</Link>
              <Link className='tag' to=''>Shirt</Link>
              <Link className='tag' to=''>T Shirt</Link>
              <Link className='tag' to=''>Women's</Link>
            </div>
          </div>
        </div>
        
        <div className='footer_bottom'>
          <div className='copyright select_n'>Copyright © 2019. All Rights Reserved.</div>
          <div className='payment_methods select_n'>
            <img src={require('../assets/images/payment-methods.png')} alt='Payment Methods' />
          </div>
        </div>
      </div>
    </footer>
  )
}
